// extracted by mini-css-extract-plugin
export default {"title":"ForthScreen_title__35pUX","description":"ForthScreen_description__RUpwg","row":"ForthScreen_row__VI22e","painSection":"ForthScreen_painSection__vn-ZW"};